"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _createIconComponent = _interopRequireDefault(require("../utils/createIconComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const ThumbsupFilledIcon = (0, _createIconComponent.default)({
  content: ( /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    d: "M3.969 14.696C4.81 15.287 8.236 16 10.413 16c.685 0 1.264-.07 1.598-.243.86-.47 2.037-3.357 2.722-5.183.93-.678 1.37-1.565 1.247-2.435-.14-.852-.773-1.548-1.739-1.843a36.115 36.115 0 00-2.107-.54c1.054-1.478 1.686-3.356 1.089-4.713C12.924.383 12.363 0 11.677 0c-1.44 0-1.896 1.287-2.212 2.226-.263.765-1.37 1.983-2.968 2.852-1.282.713-2.51 1.67-2.564 1.705a.7.7 0 00-.263.539v6.8a.7.7 0 00.299.574zM3.3 7.235v6.956c0 .609-.526 1.113-1.159 1.113A1.134 1.134 0 011 14.174v-6.94c0-.625.527-1.13 1.159-1.13S3.3 6.61 3.3 7.234z"
  })))
});
ThumbsupFilledIcon.displayName = 'ThumbsupFilledIcon';
var _default = exports.default = ThumbsupFilledIcon;